import './Accordion.scss';
import template from './Accordion.vhtml';

export default {
	name: 'Accordion',
	template: template,
	props: {
		titleField: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		open: false,
	}),
	computed: {
		toggleOpenClass() {
			if (this.open) {
				return 'accordion__title--open';
			} else {
				return '';
			}
		},
		toggleShadowClass() {
			if (this.open) {
				return 'accordion--shadow';
			} else {
				return '';
			}
		},
		toggleRotateClass() {
			if (this.open) {
				return 'accordion__icon--rotate';
			} else {
				return '';
			}
		},
	},
	methods: {
		toggleOpen() {
			this.open = !this.open;
		},
	},
};
